// Initialize Stockroom Market Discovery Platform
import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './JSComponents/App';
import { CurrencyProvider } from './context/CurrencyContext';
import { GoogleOAuthProvider } from '@react-oauth/google';
import reportWebVitals from './reportWebVitals';
import { initCapacitor } from './utils/capacitorInit';

initCapacitor();

// Prefer CRA env so local/prod clients can differ; fall back to the production web client.
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID
  || '52182837825-b7popp0oni6gfhbhnf9rmdet5l1esckt.apps.googleusercontent.com';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={googleClientId}>
      <CurrencyProvider>
        <App />
      </CurrencyProvider>
    </GoogleOAuthProvider>
  </React.StrictMode>
);

reportWebVitals();
